"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { ArrowRight, Calendar, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DurationAndInvestment() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = ["6 sesiones individuales de 60 minutos", "Material de apoyo y ejercicios prácticos", "Soporte por email entre sesiones", "Plan de acción personalizado"];
  return <section id="duración-e-inversión" className="w-full">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[80vh]">
        
        {}
        <div className="bg-[var(--color-light-background)] text-[var(--color-foreground-light)] p-12 lg:p-24 flex flex-col justify-center items-center text-center border-b lg:border-b-0 lg:border-r border-[var(--color-border)]">
          <div ref={leftRef} className={`max-w-md transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center justify-center p-4 rounded-full bg-[var(--color-muted-light-background)] mb-8">
              <SafeHydrate><Calendar className="w-8 h-8 text-[var(--color-primary)]" /></SafeHydrate>
            </div>
            
            <h2 className="text-2xl md:text-3xl font-display font-semibold mb-6 tracking-tight">
              Duración del Programa
            </h2>
            
            <div className="flex flex-col items-center justify-center my-8">
              <span className="text-8xl md:text-9xl font-display font-bold text-[var(--color-foreground-light)] leading-none tracking-tighter">
                6
              </span>
              <span className="text-2xl md:text-3xl font-display font-medium text-[var(--color-muted-foreground)] mt-2 uppercase tracking-widest">
                Semanas
              </span>
            </div>
            
            <p className="text-lg text-[var(--color-muted-foreground)] leading-relaxed">
              Un proceso intensivo y estructurado, diseñado para generar cambios profundos y sostenibles en un tiempo óptimo, sin abrumarte.
            </p>
          </div>
        </div>

        {}
        <div className="bg-[var(--color-dark-background)] text-[var(--color-foreground-dark)] p-12 lg:p-24 flex flex-col justify-center items-center text-center">
          <div ref={rightRef} className={`max-w-md w-full transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-100 ${isRightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="text-2xl md:text-3xl font-display font-semibold mb-6 tracking-tight text-[var(--color-foreground-dark)]">
              Tu Inversión
            </h2>
            
            <div className="my-8">
              <span className="text-6xl md:text-7xl font-display font-bold text-[var(--color-primary)] leading-none tracking-tight">
                €497
              </span>
              <div className="text-sm font-medium text-[var(--color-muted)] mt-4 uppercase tracking-wider opacity-80">
                Pago único o dos cuotas de €260
              </div>
            </div>

            <ul className="text-left space-y-4 mb-10 w-full max-w-sm mx-auto">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[var(--color-primary)] shrink-0 mt-0.5" />
                  <span className="text-[var(--color-foreground-dark)] opacity-90">{feature}</span>
                </li>)}
            </ul>
            
            <Link to="/ContactReserveSessionPage" className="w-full sm:w-auto inline-block">
              <Button size="lg" className="w-full sm:w-auto bg-[var(--color-primary)] text-[var(--color-foreground-primary)] hover:bg-[var(--color-primary-hover)] text-lg px-8 py-6 h-auto group">
                Reserva tu plaza
                <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
          </div>
        </div>

      </div>
    </section>;
}